<template>
	<div class="bg5 p4">
		<!-- Select Client -->
		<span class="xs-12 fw7 lh125 fs4">{{ $t("entity") }}</span>
		<core-select-client
			class="mb4"
			v-model="beneficiary"
			clientType="individual"
		></core-select-client>

		<core-form-input
			componentName="j-base-input-text"
			name="notes"
			:label="$t('notes')"
			v-model="form.notes"
		/>

		<core-form-input
			componentName="j-base-input-number"
			name="ratio"
			class="mt6"
			:label="$t('ratio')"
			v-validate="'required'"
			v-model="form.ratio"
			:validationErrors="errors"
		/>

		<!-- Buttons -->
		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave">{{
				$t("save")
			}}</j-button>
			<j-button @click="handleCancel" type="bordered">{{
				$t("cancel")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreSelectClient from "@/modules/core/components/CoreSelectClient"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import gql from "@/api/gql.js"

export default {
	components: {
		CoreFormInput,
		CoreSelectClient,
		JButton
	},

	props: {
		type: String,
		id: String,
		notes: String,
		ratio: Number,
		entity: Object
	},

	data() {
		return {
			beneficiary: [], // contains selected client id and name, mainly used for CoreSelectClient searching
			clientType: "individual",
			fetchedClient: {},
			isLoading: false,
			form: {
				notes: "",
				ratio: ""
			}
		}
	},

	methods: {
		async handleSave() {
			// Validate
			const isValid = await this.$validator.validate()
			if (!isValid) {
				this.$store.dispatch("showError", [
					"There are some missing or incorrect fields in the form"
				])
				return
			}

			if (this.type === "" || this.type === null) return
			if (this.type === "add") this.addBeneficiary()
			if (this.type === "update") this.updateBeneficiary()
		},
		async addBeneficiary() {
			const policyId = this.$route.params.id
			const beneficiaryEligibilityInput = {
				...this.form,
				entityId: this.beneficiary.length > 0 ? this.beneficiary[0].id : null
			}
			this.isLoading = true

			const res = await this.apiAddBeneficiary({
				policyId,
				beneficiaryEligibilityInput
			})

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("added")
		},
		async apiAddBeneficiary(variables) {
			const mutation = `
        mutation addBeneficiary($policyId:String!, $beneficiaryEligibilityInput: beneficiaryEligibilityInput!){
					addBeneficiaryEligibility(policyId: $policyId, beneficiaryEligibilityInput: $beneficiaryEligibilityInput ){
						status
						errors
					}
				}
      `
			const res = await gql({
				query: mutation,
				variables
			})
			return Promise.resolve(res)
		},

		async apiUpdateBeneficiary(variables) {
			const mutation = `
        mutation updateBeneficiary($policyId:String!, $beneficiaryEligibilityId:String!,$beneficiaryEligibilityInput: beneficiaryEligibilityInput! ){
					updateBeneficiaryEligibility(policyId:$policyId, beneficiaryEligibilityId:$beneficiaryEligibilityId, beneficiaryEligibilityInput: $beneficiaryEligibilityInput){
						status
					}
				}
      `
			const res = await gql({
				query: mutation,
				variables
			})
			return Promise.resolve(res)
		},

		async updateBeneficiary() {
			const policyId = this.$route.params.id
			const beneficiaryEligibilityId = this.id
			const beneficiaryEligibilityInput = {
				...this.form,
				entityId: this.beneficiary[0].id
			}
			delete beneficiaryEligibilityInput.entity
			this.isLoading = true

			const res = await this.apiUpdateBeneficiary({
				policyId,
				beneficiaryEligibilityId,
				beneficiaryEligibilityInput
			})

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("updated")
		},

		handleCancel() {
			this.$emit("cancelled")
		},

		initialize() {
			if (this.type === "add") return

			if (this.entity) {
				this.beneficiary = [this.entity]
				if (this.beneficiary[0].identities)
					delete this.beneficiary[0].identities
			}

			this.form = {
				entity: this.entity,
				notes: this.notes,
				ratio: this.ratio
			}
		}
	},

	mounted() {
		this.initialize()
	}
}
</script>
